import { combineReducers } from 'redux'
import axios from 'axios'
import moment from 'moment'
import { convertSportsForApi, convertToMapSports, fetchUrlParams } from '../utils/utilities'

// globally interchangeable parameters, see config.js
// !!! DONT REMOVE THE ESLINT-IGNORE COMMENTS !!!

const fetchedUrlParams = fetchUrlParams()

// eslint-disable-next-line
const uiEmbedded = !!fetchedUrlParams.embedded
// eslint-disable-next-line
const apiUrl = globalApiUrl
// eslint-disable-next-line
const apiUser = globalApiUser
// eslint-disable-next-line
const apiPassword = globalApiPassword
// eslint-disable-next-line
const apiHeaders = globalApiHeaders
// eslint-disable-next-line
const defaultSport = fetchedUrlParams.sport ? fetchedUrlParams.sport : "Alle"
// eslint-disable-next-line
const defaultDate = fetchedUrlParams.date ? moment(fetchedUrlParams.date, fetchedUrlParams.dateFormat) : (globalDefaultDate === 'today' ? moment() : moment(globalDefaultDate, 'YYYY-MM-DD'))
// eslint-disable-next-line
const defaultDateUntil = moment(defaultDate).add((fetchedUrlParams.days ? fetchedUrlParams.days : globalDefaultDateUntil), 'days')
// eslint-disable-next-line
const defaultLimit = globalDefaultLimit
// eslint-disable-next-line
const filterVirtual = globalApiFilterVirtual === true
// eslint-disable-next-line
const defaultPublicState = false
// eslint-disable-next-line
const defaultZip = fetchedUrlParams.plz ? fetchedUrlParams.plz : ''
// eslint-disable-next-line
const defaultRadius = fetchedUrlParams.km ? fetchedUrlParams.km : 0

// parameters that aren't globally interchangeable
let isMobile = window.innerWidth <= 380 ? true : false
const defaultViewport = {
  center: isMobile ? { lat: 52.89, lng: 10.84 } : { lat: 51.49, lng: 11.34 },
  zoom: 6
}

// -- -- -- -- -- -- -- -- -- -- -- \\
/* -- ACTIONS -- */
// -- -- -- -- -- -- -- -- -- -- -- \\

export const EVENTSDATA_REQUEST = 'EVENTSDATA_REQUEST'
export const EVENTSDATA_RECEIVED = 'EVENTSDATA_SUCCESS'
export const RESOLVE_API_ERROR = 'RESOLVE_API_ERROR'

export const SET_URL_PARAMS = 'SET_URL_PARAMS'
export const SET_PRESELECTED_PLACE = 'SET_PRESELECTED_PLACE'
export const SET_VISIBLE_EVENTS = 'SET_VISIBLE_EVENTS'
export const SET_FILTERED_EVENTS = 'SET_FILTERED_EVENTS'
export const SET_ACTIVE_EVENTITEM = 'SET_ACTIVE_EVENTITEM'

export const SET_FILTER_DATE = 'SET_FILTER_DATE'
export const SET_FILTER_DATE_UNTIL = 'SET_FILTER_DATE_UNTIL'
export const SET_FILTER_ZIP = 'SET_FILTER_ZIP'
export const SET_FILTER_RADIUS = 'SET_FILTER_RADIUS'
export const SET_FILTER_ATTENDEES = 'SET_FILTER_ATTENDEES'
export const SET_FILTER_SPORT = 'SET_FILTER_SPORT'
export const SET_FILTER_PREMIUM = 'SET_FILTER_PREMIUM'
export const SET_FILTER_PUBLICSTATE = 'SET_FILTER_PUBLICSTATE'

export const MAP_VIEWPORT = 'MAP_VIEWPORT'
export const SHOW_RESULTS = 'SHOW_RESULTS'

// -- -- -- -- -- -- -- -- -- -- -- \\
/* -- ACTIONCREATORS -- */
// -- -- -- -- -- -- -- -- -- -- -- \\

export function isEmbedded() {
  return uiEmbedded
}

export function isFilterVirtual() {
  return filterVirtual
}

function resolveApiError(sport) {
  return {
    type: RESOLVE_API_ERROR,
    sport
  }
}

function eventsDataRequest(sport) {
  return {
    type: EVENTSDATA_REQUEST,
    sport
  }
}

function eventsDataReceived(sport, zip, date, dateUntil, data) {
  return {
    type: EVENTSDATA_RECEIVED,
    sport,
    zip,
    date,
    dateUntil,
    events: data.events.map((e) => {e.visibleOnMap = true; return e})
  }
}

function setPreselectedPlace(data) {
  return {
    type: SET_PRESELECTED_PLACE,
    place: data.searched.place,
  }
}

function setFilteredEvents(sport, zip, date, dateUntil, radius, attendees, premium, publicState, state) {
  return {
    type: SET_FILTERED_EVENTS,
    sport,
    zip,
    date,
    dateUntil,
    radius,
    attendees,
    filterPremium: premium,
    publicState,
    events: state.eventsBySport[sport].items.filter(lrsEvent => {
      const distance = lrsEvent.distance ? parseFloat(lrsEvent.distance) : 99999999.99
      const radius = state.filterRadius ? parseFloat(state.filterRadius * 1000) : 0
      let isInsideRadius = state.filterRadius ? distance <= radius : true
      let hasAttendees = !attendees || (Number(lrsEvent.attendee) >= Number(attendees))
      let isPremium = !premium || lrsEvent.premium === true
      let hasPublicState = !publicState || lrsEvent.publicState === publicState
      return hasAttendees && isPremium && hasPublicState && isInsideRadius
    })
  }
}

export function setVisibleEvents(events, listOfVisibles=[]) {
  return {
    type: SET_VISIBLE_EVENTS,
    events,
    listOfVisibles,
  }
}

function getEventsData(sport, zip, date, dateUntil, limit) {
  return (dispatch, getState) => {
    const { filterZip, filterRadius, filterAttendees, filterPremium, filterPublicState } = getState()
    dispatch(eventsDataRequest(sport))
    axios(apiUrl, {
      headers: apiHeaders,
      auth: { username: apiUser, password: apiPassword },
      params: {
        sport: convertSportsForApi(sport),
        zip: filterZip,
        radius: filterRadius,
        date: moment(date).format('YYYY-MM-DD'),
        until: moment(dateUntil).format('YYYY-MM-DD'),
        limit: defaultLimit,
        virtual: filterVirtual
      }
    })
    .then(response => {
      dispatch(setPreselectedPlace(response.data))
      dispatch(eventsDataReceived(sport, zip, date, dateUntil, response.data))
      dispatch(setFilteredEvents(sport, zip, date, dateUntil, filterRadius, filterAttendees, filterPremium, filterPublicState, getState()))
    })
    .catch(function(error) {
      console.log(error)
      dispatch(resolveApiError(sport))
    })
  }
}

function shouldGetEventsData(sport, zip, date, dateUntil, state) {
  const events = state.eventsBySport[sport]

  if (!events) {
    return true
  } else if (events) {
    const stateSport = state.eventsBySport[sport].sport
    const stateZip = state.eventsBySport[sport].zip
    const stateDate = state.eventsBySport[sport].date
    const stateDateUntil = state.eventsBySport[sport].dateUntil

    if (stateSport !== sport || !stateZip || stateZip !== zip || stateDate !== date || stateDateUntil !== dateUntil) {
      return true
    }
  } else if (events.isRequesting) {
    return false
  }
}

export function getEventsDataIfNeeded(sport, zip, date, dateUntil, limit) {
  return (dispatch, getState) => {
    const { filterRadius, filterAttendees, filterPremium, filterPublicState } = getState()
    if (shouldGetEventsData(sport, zip, date, dateUntil, getState())) {
      return dispatch(getEventsData(sport, zip, date, dateUntil, limit))
    } else {
      return dispatch(setFilteredEvents(sport, zip, date, dateUntil, filterRadius, filterAttendees, filterPremium, filterPublicState, getState()))
    }
  }
}

export function setActiveEventitem(id, viewport) {
  return dispatch => {
    Promise.resolve(dispatch(activeEventSetter(id))).then(function() {
      if (viewport) {
        dispatch(setMapViewport(viewport))
      }
    })
  }
}

function activeEventSetter(id) {
  return {
    type: SET_ACTIVE_EVENTITEM,
    id
  }
}

export function switchResults(isShowing) {
  return {
    type: SHOW_RESULTS,
    isShowing
  }
}

export function setMapViewport(viewport) {
  return {
    type: MAP_VIEWPORT,
    viewport
  }
}

export function handleFilterChange(value, filterType) {
  // is called by the fnc in the main App, on filter component change
  // calls the setFilters to write the new global filter params state
  // after, calls the validation, to preserve the correct content of filteredEvents obj. with right params
  return (dispatch, getState) => {
    const oldSport = getState().filterSport
    Promise.resolve(dispatch(setFilters(value, filterType))).then(function() {
      dispatch(validateValidation(oldSport))
    })
  }
}

function validateValidation(oldSport) {
  return (dispatch, getState) => {
    const { eventsBySport, filterSport, filterZip, filterDate, filterDateUntil } = getState()
    if (validateFilters(oldSport, filterSport, filterZip, filterDate, filterDateUntil, eventsBySport)) {
      return dispatch(getEventsDataIfNeeded(filterSport, filterZip, filterDate, filterDateUntil))
    }
  }
}

export function setPublicState(publicState) {
  return (dispatch, getState) => {
    Promise.resolve(dispatch(setFilterPublicState(publicState))).then(function() {
      const { filterSport, filterZip, filterDate, filterDateUntil } = getState()
      return dispatch(getEventsDataIfNeeded(filterSport, filterZip, filterDate, filterDateUntil))
    })
  }
}

function validateFilters(oldSport, newSport, zip, date, dateUntil, gE) {
  // check, if the filter params are matching the filters, that are used to fetch the recent [sport] sportevents
  const eventsZip = gE[oldSport].zip
  const eventsDate = gE[oldSport].date
  const eventsDateUntil = gE[oldSport].dateUntil

  if (oldSport !== newSport || !zip || zip !== eventsZip || date !== eventsDate || dateUntil !== eventsDateUntil) {
    return true
  } else {
    return false
  }
}

function setFilters(value, filterType) {
  switch (filterType) {
    case 'sportFilter':
      return dispatch => {
        dispatch(setFilterSport(value))
      }
    case 'premiumFilter':
      return dispatch => {
        dispatch(setFilterPremium(value))
      }
    case 'zipFilter':
      return dispatch => {
        dispatch(setFilterZip(value))
      }
    case 'dateFilter':
      return dispatch => {
        dispatch(setFilterDate(value))
      }
    case 'dateFilterUntil':
      return dispatch => {
        dispatch(setFilterDateUntil(value))
      }
    case 'radiusFilter':
      return (dispatch, getState) => {
        const { filterSport, filterZip, filterDate, filterDateUntil, filterAttendees, filterPremium, filterPublicState } = getState()
        dispatch(setFilterRadius(value))
        dispatch(setFilteredEvents(filterSport, filterZip, filterDate, filterDateUntil, value, filterAttendees, filterPremium, filterPublicState, getState()))
      }
    case 'attendeesFilter':
      return dispatch => {
        dispatch(setFilterAttendees(value))
      }
    case 'publicState':
      return dispatch => {
        dispatch(setFilterPublicState(value))
      }
    default:
      break
  }
}

function setFilterSport(sport) {
  return {
    type: SET_FILTER_SPORT,
    sport
  }
}

function setFilterPremium(isShowing) {
  return {
    type: SET_FILTER_PREMIUM,
    isShowing
  }
}

function setFilterZip(zip) {
  return {
    type: SET_FILTER_ZIP,
    zip
  }
}

function setFilterDate(date) {
  return {
    type: SET_FILTER_DATE,
    date: date
  }
}

function setFilterDateUntil(dateUntil) {
  return {
    type: SET_FILTER_DATE_UNTIL,
    dateUntil: dateUntil
  }
}

function setFilterRadius(radius) {
  return {
    type: SET_FILTER_RADIUS,
    radius
  }
}

function setFilterAttendees(attendees) {
  return {
    type: SET_FILTER_ATTENDEES,
    attendees
  }
}

function setFilterPublicState(publicState) {
  return {
    type: SET_FILTER_PUBLICSTATE,
    publicState
  }
}

// -- -- -- -- -- -- -- -- -- -- -- \\
/* -- REDUCERS -- */
// -- -- -- -- -- -- -- -- -- -- -- \\

function sanitizeEvents(orgEvents) {
  let geoEvents = orgEvents.filter((event) => {
    let latOk = (event.latitude !== null) && (!isNaN(event.latitude))
    let lngOk = (event.longitude !== null) && (!isNaN(event.longitude))
    // if (!(latOk && lngOk)) {
    //   console.log("ignore event because of missing geolocation", event)
    // }
    return (latOk && lngOk)
  })
  const today = moment().format('YYYY-MM-DD')
  var posCache = {}
  var validEvents = geoEvents.map((event) => {
    var key = "lat"+event.latitude+"lng"+event.longitude
    if (posCache[key] === "taken") {
      var latOff = ((Math.random() * 5) + 1) / 10000
      var lngOff = ((Math.random() * 5) + 1) / 10000
      var latAdd = (Math.random() > 0.5) ? 1 : -1
      var lngAdd = (Math.random() > 0.5) ? 1 : -1
      var latDelta = (latAdd * latOff)
      var lngDelta = (lngAdd * lngOff)
      event.latitude += latDelta
      event.longitude += lngDelta
      key = "lat"+event.latitude+"lng"+event.longitude
      // console.log("delocated event because of identical position", "(",latDelta,"/",lngDelta,")", event)
    }
    const sd = moment(event['date-from'], 'YYYY-MM-DD')
    const ed = moment(event['date-to'], 'YYYY-MM-DD')
    const pr = event.premium === true ? 'A' : 'B'
    if (moment(sd).isAfter(today)) {
      event.listSort = pr + 'B-'+sd
    }
    else if (moment(ed).isBefore(today)) {
      event.listSort = pr + 'C-'+sd
    }
    else {
      event.listSort = pr + 'A-'+sd
    }
    event.mapIconSport = 'Multisport'
    if (event.contests === 1) {
      event.mapIconSport = convertToMapSports(event.contest[0].sport)
    } else {
      const sports = {}
      event.contest.forEach(c => (sports[c.sport] = true))
      if (Object.keys(sports).length === 1) {
        event.mapIconSport = convertToMapSports(Object.keys(sports)[0])
      }
    }
    
    posCache[key] = "taken"
    return event
  })
  validEvents.sort((a,b) => {
    return (a.listSort > b.listSort) - (a.listSort < b.listSort)
  })
  return validEvents
}

function eventsData(
  state = {
    isRequesting: false,
    sport: defaultSport,
    date: defaultDate,
    dateUntil: defaultDateUntil,
    zip: defaultZip,
    radius: defaultRadius,
    publicState: false,
    items: []
  },
  action
) {
  switch (action.type) {
    case EVENTSDATA_REQUEST:
      return Object.assign({}, state, {
        isRequesting: true
      })
    case RESOLVE_API_ERROR:
      return Object.assign({}, state, {
        isRequesting: false
      })
    case EVENTSDATA_RECEIVED:
      return Object.assign({}, state, {
        isRequesting: false,
        sport: action.sport,
        zip: action.zip,
        date: action.date,
        dateUntil: action.dateUntil,
        items: sanitizeEvents(action.events)
      })
    default:
      return state
  }
}

function filteredEvents(
  state = {
    sport: defaultSport,
    date: defaultDate,
    dateUntil: defaultDateUntil,
    zip: defaultZip,
    radius: defaultRadius,
    attendees: '',
    publicState: false,
    items: []
  },
  action
) {
  switch (action.type) {
    case SET_FILTERED_EVENTS:
      return Object.assign({}, state, {
        sport: action.sport,
        zip: action.zip,
        date: action.date,
        dateUntil: action.dateUntil,
        radius: action.radius,
        attendees: action.attendees,
        publicState: action.pubicState,
        items: sanitizeEvents(action.events)
      })
    case SET_VISIBLE_EVENTS:
      return Object.assign({}, state, {
        items: action.events.map((e) => {e.visibleOnMap = (action.listOfVisibles.indexOf(e.id) > -1); return e})
      })
    default:
      return state
  }
}

function mapViewport(state = defaultViewport, action) {
  switch (action.type) {
    case MAP_VIEWPORT:
      return action.viewport
    default:
      return state
  }
}

function eventsBySport(state = {}, action) {
  switch (action.type) {
    case EVENTSDATA_RECEIVED:
    case EVENTSDATA_REQUEST:
    case RESOLVE_API_ERROR:
      return Object.assign({}, state, {
        [action.sport]: eventsData(state[action.sport], action)
      })

    default:
      return state
  }
}

function preselectedPlace(state = {}, action) {
  switch (action.type) {
    case SET_PRESELECTED_PLACE:
      return Object.assign({}, state, {
        uiName: action.place
      })
    default:
      return state
  }
}

function activeEventItem(state = null, action) {
  switch (action.type) {
    case SET_ACTIVE_EVENTITEM:
      return action.id
    default:
      return state
  }
}

function showResults(state = false, action) {
  switch (action.type) {
    case SHOW_RESULTS:
      return !state
    default:
      return state
  }
}

function filterPremium(state = false, action) {
  switch (action.type) {
    case SET_FILTER_PREMIUM:
      return !state
    default:
      return state
  }
}

function filterDate(state = defaultDate, action) {
  switch (action.type) {
    case SET_FILTER_DATE:
      return action.date
    default:
      return state
  }
}

function filterDateUntil(state = defaultDateUntil, action) {
  switch (action.type) {
    case SET_FILTER_DATE_UNTIL:
      return action.dateUntil
    default:
      return state
  }
}

function filterZip(state = defaultZip, action) {
  switch (action.type) {
    case SET_FILTER_ZIP:
      return action.zip
    default:
      return state
  }
}

function filterRadius(state = defaultRadius, action) {
  switch (action.type) {
    case SET_FILTER_RADIUS:
      return action.radius
    default:
      return state
  }
}

function filterAttendees(state = 0, action) {
  switch (action.type) {
    case SET_FILTER_ATTENDEES:
      return action.attendees
    default:
      return state
  }
}

function filterSport(state = defaultSport, action) {
  switch (action.type) {
    case SET_FILTER_SPORT:
      return action.sport
    default:
      return state
  }
}

function filterPublicState(state = defaultPublicState, action) {
  switch (action.type) {
    case SET_FILTER_PUBLICSTATE:
      return action.publicState
    default:
      return state
  }
}

// -- -- -- -- -- -- -- -- -- -- -- \\
/* -- COMBINING ALL REDUCERS -- */
// -- -- -- -- -- -- -- -- -- -- -- \\
const eventmapReducers = combineReducers({
  mapViewport,
  activeEventItem,
  showResults,
  filterPremium,
  filterDate,
  filterDateUntil,
  filterZip,
  filterRadius,
  filterAttendees,
  filterSport,
  eventsBySport,
  filteredEvents,
  filterPublicState,
  preselectedPlace,
})
export default eventmapReducers



// WEBPACK FOOTER //
// ./src/components/actionsReducers.js